export default "__VITE_ASSET__DsAWAf8J__"